import { addCommasToNumber } from '../../../../Utils/CommonUtils';
import {
  getPercentageDiff,
  getRupeePercentagePrefix,
} from '../../../price_cards/utils';
import { IPartnerPlanData } from '../../../types';

interface CompactCardData {
  price: string;
  originalPrice: string;
  discount: string;
  couponCode?: string;
  couponDiscount?: string;
  listingId: string;
  planId: string;
}

interface CompactCardsData {
  luxury: CompactCardData;
  expert: CompactCardData;
}

export const transformCompactCardsData = (
  luxuryPlanData: IPartnerPlanData[],
  expertSessionData: IPartnerPlanData[]
): CompactCardsData | null => {
  if (
    luxuryPlanData.length === 0 ||
    expertSessionData.length === 0 ||
    !luxuryPlanData[0]?.planDetails?.pricing ||
    !expertSessionData[0]?.planDetails?.pricing
  ) {
    return null;
  }

  const luxuryPricing = luxuryPlanData[0].planDetails.pricing;
  const luxuryDiscountedPrice = Math.floor(luxuryPricing.discountedPrice);
  const luxuryListPrice = Math.floor(luxuryPricing.listPrice);
  const luxuryCoupon = luxuryPlanData[0].coupon;

  const expertPricing = expertSessionData[0].planDetails.pricing;
  const expertDiscountedPrice = Math.floor(expertPricing.discountedPrice);
  const expertListPrice = Math.floor(expertPricing.listPrice);
  const expertCoupon = expertSessionData[0].coupon;

  return {
    luxury: {
      price: `₹${addCommasToNumber(luxuryDiscountedPrice, 0)}`,
      originalPrice: `₹${addCommasToNumber(luxuryListPrice, 0)}`,
      discount: `-${getPercentageDiff(
        luxuryListPrice,
        luxuryDiscountedPrice
      )}%`,
      couponCode: luxuryCoupon?.code,
      couponDiscount: luxuryCoupon
        ? getRupeePercentagePrefix(
            luxuryCoupon.discountType,
            luxuryCoupon.discountValue
          )
        : undefined,
      listingId: luxuryPlanData[0].planDetails.listingId,
      planId: luxuryPlanData[0].planDetails.planId,
    },
    expert: {
      price: `₹${addCommasToNumber(expertDiscountedPrice, 0)}`,
      originalPrice: `₹${addCommasToNumber(expertListPrice, 0)}`,
      discount: `-${getPercentageDiff(
        expertListPrice,
        expertDiscountedPrice
      )}%`,
      couponCode: expertCoupon?.code,
      couponDiscount: expertCoupon
        ? getRupeePercentagePrefix(
            expertCoupon.discountType,
            expertCoupon.discountValue
          )
        : undefined,
      listingId: expertSessionData[0].planDetails.listingId,
      planId: expertSessionData[0].planDetails.planId,
    },
  };
};
